import { Menu, Waves } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import { NotificationBell } from '@/components/notifications';

interface HeaderProps {
  onMenuClick: () => void;
}

export function Header({ onMenuClick }: HeaderProps) {
  return (
    <div className="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6">
      <button
        type="button"
        className="-m-2.5 p-2.5 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
        onClick={onMenuClick}
      >
        <span className="sr-only">Open sidebar</span>
        <Menu className="h-6 w-6" aria-hidden="true" />
      </button>

      {/* Mobile logo */}
      <Link to="/overview" className="flex min-h-11 items-center gap-2">
        <div className="w-7 h-7 rounded-md bg-primary-600 flex items-center justify-center">
          <Waves className="w-4 h-4 text-white" />
        </div>
        <span className="text-lg font-bold text-gray-900">HiponHero</span>
      </Link>

      {/* Right side - notifications */}
      <div className="ml-auto">
        <NotificationBell />
      </div>
    </div>
  );
}
